function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Vector = /*#__PURE__*/function () {
  function Vector(x, y) {
    _classCallCheck(this, Vector);
    this.x = x || 0;
    this.y = y || 0;
  }
  _createClass(Vector, [{
    key: "add",
    value: function add(v) {
      return new Vector(this.x + v.x, this.y + v.y);
    }
  }, {
    key: "subtract",
    value: function subtract(v) {
      return new Vector(this.x - v.x, this.y - v.y);
    }
  }, {
    key: "addScalar",
    value: function addScalar(n) {
      return new Vector(this.x + n, this.y + n);
    }
  }, {
    key: "subtractScalar",
    value: function subtractScalar(n) {
      return new Vector(this.x - n, this.y - n);
    }
  }, {
    key: "multiplyByScalar",
    value: function multiplyByScalar(n) {
      return new Vector(this.x * n, this.y * n);
    }
  }, {
    key: "negate",
    value: function negate() {
      return new Vector(-this.x, -this.y);
    }
  }, {
    key: "magnitude",
    value: function magnitude() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var magnitude = this.magnitude();
      return new Vector(this.x / magnitude, this.y / magnitude);
    }
  }, {
    key: "perpendicular",
    value: function perpendicular() {
      var clockwise = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return clockwise ? new Vector(this.y, -this.x) : new Vector(-this.y, this.x);
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this.x, this.y];
    }
  }], [{
    key: "fromArray",
    value: function fromArray(arr) {
      if (arr.length !== 2) throw new Error("'arr' length must be 2.");
      return new Vector(arr[0], arr[1]);
    }
  }, {
    key: "dot",
    value: function dot(u, v) {
      return u.x * v.x + u.y * v.y;
    }
  }, {
    key: "distance",
    value: function distance(v, u) {
      return u.subtract(v).magnitude();
    }
  }, {
    key: "angleBetween",
    value: function angleBetween(a, b) {
      var p = a.x * b.x + a.y * b.y;
      var n = Math.sqrt((Math.pow(a.x, 2) + Math.pow(a.y, 2)) * (Math.pow(b.x, 2) + Math.pow(b.y, 2)));
      var sign = a.x * b.y - a.y * b.x < 0 ? -1 : 1;
      var angle = Math.acos(p / n);
      return sign * angle;
    }
  }]);
  return Vector;
}();
export { Vector as default };